import React, { Component } from 'react';
import './CreatorUploadMonetizationForm.css';

class CreatorMonetizationImpressionPercentageForm extends Component {
  constructor(props) {
    super(props);
    this.state = {value: (props.params && props.params.impressionPercentage ? props.params.impressionPercentage : "")};

    this.handleChange = this.handleChange.bind(this);

  }

  handleChange(event) {
    if(this.props.checkString(event.target.value) || event.target.value === ""){
      this.setState({value: event.target.value});
      this.props.setImpressionPercentage(event.target.value);
    }
  }

  render() {
    return (
      <div>
        <label className="text-black">
          <input placeholder="Impression fee % split" className="placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900" type="text" value={this.state.value} onChange={this.handleChange} />
        </label>
        How much of the impression fee you would like to take vs your NFT holders.
        Ex. if you have set your impression fee % share to be 80% then 80% of the total revenue will be distributed to you and 20% will be distributed to the NFT holders
      </div>
    );
  }
}

export default CreatorMonetizationImpressionPercentageForm;
